import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: Cookies.get("token") || "",
    img_url: Cookies.get("img_url") || "",
  },
  getters: {
    imgUrl(state) {
      return state.img_url;
    },
    isLogin(state) {
      return Boolean(state.token);
    },
  },
  mutations: {
    SET_USERINFO: (state, data) => {
      const { ut, img_url, autologin } = data;
      state.token = ut;
      state.img_url = img_url;
      const expires = autologin ? 7 : 3;
      Cookies.set("token", ut, { expires });
      Cookies.set("img_url", img_url, { expires });
    },
    CLEAR_USERINFO: (state) => {
      Cookies.remove("token");
      Cookies.remove("img_url");
      state.token = "";
      state.img_url = "";
    },
  },
  actions: {},
  modules: {},
});
